// extracted by mini-css-extract-plugin
module.exports =  {"wrap":"_772e1b1e50--wrap--ixjmB","tabs":"_772e1b1e50--tabs--IPCnG","wrap-left-blur":"_772e1b1e50--wrap-left-blur--eGM8k","wrap-right-blur":"_772e1b1e50--wrap-right-blur--e3QBO"};